import { Box, Button, Typography } from '@mui/material';
import { connect } from 'formik';
import { bool, func, object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import InviteSwitch from './InviteSwitch';

const EmployeeActions = ({ onReset, formik, isEdit }) => {
  const handleReset = e => {
    if (typeof onReset === 'function') {
      onReset(e);
    }
    formik.handleReset(e);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      {!isEdit && <InviteSwitch />}
      <Box sx={{ display: 'flex', alignItems: 'center', pt: '20px' }}>
        {formik.errors.server && (
          <Typography align="right" color="error" sx={{ px: '20px', alignSelf: 'center' }}>
            {typeof formik.errors.server === 'object' && formik.errors.server.message
              ? formik.errors.server.message
              : typeof formik.errors.server === 'string'
                ? formik.errors.server
                : JSON.stringify(formik.errors.server)}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', justifySelf: 'flex-end', pt: '20px' }}>
        <Button
          variant="outlined"
          onClick={handleReset}
          disabled={formik.isSubmitting}
          sx={{ color: 'primary.ultraDark', mr: '10px' }}
          type="reset"
          color="secondary"
        >
          {I18n.t('EmployeeDrawer.Cancel')}
        </Button>
        <Button variant="contained" disabled={formik.isSubmitting} color="primary" type="submit">
          {formik.isSubmitting
            ? `${
                isEdit
                  ? I18n.t('EmployeeDrawer.EmployeeButton.Updating')
                  : I18n.t('EmployeeDrawer.EmployeeButton.Creating')
              } ${I18n.t('EmployeeDrawer.EmployeeButton.employee')}...`
            : `${
                isEdit
                  ? I18n.t('EmployeeDrawer.EmployeeButton.Update')
                  : I18n.t('EmployeeDrawer.EmployeeButton.Create')
              } ${I18n.t('EmployeeDrawer.EmployeeButton.employee')}`}
        </Button>
      </Box>
    </Box>
  );
};

EmployeeActions.propTypes = {
  onReset: func.isRequired,
  isEdit: bool.isRequired,
  formik: object.isRequired,
};

export default connect(EmployeeActions);
